var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconScan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 5H31V8H35V12H38V7C38 5.89543 37.1046 5 36 5ZM4 35H9V32H5V28H2V33C2 34.1046 2.89543 35 4 35ZM31 35H36C37.1046 35 38 34.1046 38 33V28H35V32H31V35ZM4 5H9V8H5V12H2V7C2 5.89543 2.89543 5 4 5ZM10.5 22.25V17.75H15.25V22.25H10.5ZM20 22.25V26.5H15.25V22.25H20ZM20 17.75V22.25H24.75V26.5H29.5V22.25H24.75V17.75H29.5V13.5H24.75V17.75H20ZM20 17.75V13.5H15.25V17.75H20ZM8 12C8 11.4477 8.44772 11 9 11H31C31.5523 11 32 11.4477 32 12V28C32 28.5523 31.5523 29 31 29H9C8.44772 29 8 28.5523 8 28V12Z",
    fill: "#FFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScan);
export default __webpack_public_path__ + "static/media/iconScan.63da2257.svg";
export { ForwardRef as ReactComponent };